export default "__VITE_ASSET__UCi9DtCX__"